// extracted by mini-css-extract-plugin
export var button = "_c4-4";
export var hasDarkBackground = "_c4-7";
export var hasLightBackground = "_c4-6";
export var iconWrapper = "_c4-0";
export var large = "_c4-2";
export var medium = "_c4-1";
export var small = "_c4-5";
export var xsmall = "_c4-3";